export default __webpack_public_path__ + "asset/img/icon-close~e40d06e4.png";